import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import { CombinedContext } from '@ustra/nuxt/src/vue/store'
import { logger } from '@ustra/core'
import { localStorage } from '@ustra/core/src/utils/storage/local-storage'
import { Mobile } from '@ustra/nuxt/src/vue/plugins/func/mobile'
import initialDataService, { AppProp } from '../../services/initial-data-service'
import * as storageKey from './storage-key'

export interface CommonDataState {
  mobile: Mobile
  deviceId: string
  appProp: AppProp
}

@Module({
  name: 'cmData',
  namespaced: true,
  stateFactory: true,
})
export class CommonDataModule extends VuexModule implements CommonDataState {
  /**
   * 모바일
   */
  mobile: Mobile = null

  /**
   * 디바이스 아이디
   */
  deviceId: string = null

  /**
   * 어플리케이션 설정
   */
  appProp: AppProp = null

  /**
   * 리프레시 토큰
   */
  refreshToken: string = null

  @Mutation
  setMobile(mobile: Mobile) {
    this.mobile = mobile
  }

  @Mutation
  setAppProp(appProp: AppProp) {
    this.appProp = appProp
  }

  @Mutation
  setRefreshToken(refreshToken: string) {
    this.refreshToken = refreshToken
  }

  @Mutation
  private async loadDeviceId(newDeviceId: string) {
    let deviceId = this.mobile.isNativeRequest ? await this.mobile.bridge.staticFunctions.storage().getItem(storageKey.DEVICE_ID) : localStorage.getItem(storageKey.DEVICE_ID)

    // 디바이스 아이디 생성
    if (!deviceId) {
      deviceId = newDeviceId
      if (this.mobile.isNativeRequest) await this.mobile.bridge.staticFunctions.storage().setItem(storageKey.DEVICE_ID, deviceId)
      else localStorage.setItem(storageKey.DEVICE_ID, deviceId)
    }

    this.deviceId = deviceId
  }

  @Action
  nuxtServerInit(_arg: CombinedContext) {}

  @Action
  async nuxtClientInit(_arg: CombinedContext) {
    // 초기 데이터 셋업
    const initData = await initialDataService.getInitialData()
    // logger().debug({ message: '초기 데이터 조회', args: [initData] })

    this.setMobile(_arg.context.$ustra.mobile)
    this.setAppProp(initData.appProp)
    await this.loadDeviceId(initData.deviceId)
  }
}
